export const MAX_ICON_PATH = 'M50.76 0c27.53 0 49.12 22.34 49.12 49.89S77.61 99.23 51.02 99.23c-9.43 0-14.01-1.33-21.37-6.54-.5-.36-1.2-.26-1.63.19-5.66 6.04-20.17 10.28-20.83 2.03C7.19 80.53 0 71.18 0 49.61 0 21.3 23.22 0 50.76 0m.77 24.55c-13.07-.68-23.26 8.39-25.51 22.58-1.86 11.75 1.44 26.07 4.26 26.8 1.2.3 4.08-1.9 6.18-3.88.4-.37.99-.44 1.45-.15 3.27 2 6.97 3.5 11.05 3.71 13.42.7 25.3-9.8 26-23.21.71-13.42-10.01-25.14-23.43-25.85';

export const MAX_ICON_WHITE_24 = `
    <svg width="24" height="24" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="${MAX_ICON_PATH}"/>
    </svg>
`;

export const MAX_ICON_COLORED_24 = `
    <svg width="24" height="24" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
            <linearGradient id="tourist-leads-max-gradient" x1="0" y1="100" x2="100" y2="0" gradientUnits="userSpaceOnUse">
                <stop stop-color="#00BFFF"/>
                <stop offset="1" stop-color="#9500FF"/>
            </linearGradient>
        </defs>
        <path fill="url(#tourist-leads-max-gradient)" fill-rule="evenodd" clip-rule="evenodd" d="${MAX_ICON_PATH}"/>
    </svg>
`;
